import clsx from "clsx";
import type { ResourceCardProps } from "@/features/Dashboard";
import { getProposalColorClasses, SENIORITY_ORDER } from "@/features/Dashboard";
import Thermometer from "@/components/proposals/Thermometer";
import { RESOURCE_CARD_CLASSES } from "./resourceCard.definitions";

export default function ResourceCard({
  resource,
  typeId,
  onProposalClick,
  getTypeName,
  getTechnologyName,
  getProposalByName,
}: ResourceCardProps) {
  return (
    <div className={RESOURCE_CARD_CLASSES.container}>
      <div className={RESOURCE_CARD_CLASSES.header}>
        <div className="flex justify-between items-center">
          <h4 className={RESOURCE_CARD_CLASSES.title}>{getTypeName(typeId)}</h4>
          <span className={RESOURCE_CARD_CLASSES.totalBadge}>
            Total: {resource.total}
          </span>
        </div>
      </div>

      <div className={RESOURCE_CARD_CLASSES.grid}>
        {/* Senioridades */}
        <div className={RESOURCE_CARD_CLASSES.section}>
          <h5 className={RESOURCE_CARD_CLASSES.sectionTitle}>Senioridade</h5>
          <div className="space-y-2">
            {SENIORITY_ORDER.map((seniority) => (
              <div
                key={seniority}
                className={RESOURCE_CARD_CLASSES.seniorityItem}
              >
                <span className={RESOURCE_CARD_CLASSES.seniorityLabel}>
                  {seniority}
                </span>
                <span className={RESOURCE_CARD_CLASSES.seniorityBadge}>
                  {resource.seniorities[seniority]?.total || 0}
                </span>
              </div>
            ))}
          </div>
        </div>

        {/* Tecnologias */}
        <div className={RESOURCE_CARD_CLASSES.section}>
          <h5 className={RESOURCE_CARD_CLASSES.sectionTitle}>Tecnologias</h5>
          <div className="space-y-2">
            {Object.entries(resource.technologies).map(([techId, count]) => (
              <div
                key={techId}
                className={RESOURCE_CARD_CLASSES.technologyItem}
              >
                <span className={RESOURCE_CARD_CLASSES.technologyLabel}>
                  {getTechnologyName(techId)}
                </span>
                <span className={RESOURCE_CARD_CLASSES.technologyBadge}>
                  {count}
                </span>
              </div>
            ))}
          </div>
        </div>

        {/* Propostas */}
        <div className={RESOURCE_CARD_CLASSES.section}>
          <h5 className={RESOURCE_CARD_CLASSES.sectionTitle}>Propostas</h5>
          <div className="flex flex-wrap gap-1.5">
            {Array.from(resource.proposals).map((proposalName, index) => {
              const proposalData = getProposalByName(proposalName);
              if (!proposalData) return null;

              return (
                <button
                  key={index}
                  onClick={() => onProposalClick(proposalData)}
                  className={clsx(
                    RESOURCE_CARD_CLASSES.proposalButton,
                    getProposalColorClasses(proposalData.heatLevel)
                  )}
                >
                  <Thermometer
                    heatLevel={proposalData.heatLevel}
                    mode="display"
                    className="!p-0"
                    customText={proposalData.name}
                  />
                </button>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}
